var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#854ECA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2283 10.388L20.595 13.2427L16.1522 7.31654C16.1343 7.29269 16.1111 7.27333 16.0844 7.25999C16.0578 7.24666 16.0284 7.23972 15.9986 7.23972C15.9688 7.23972 15.9394 7.24666 15.9127 7.25999C15.8861 7.27333 15.8629 7.29269 15.845 7.31654L11.4045 13.2427L6.76882 10.388C6.63311 10.3046 6.45692 10.4165 6.47835 10.5761L8.29739 24.3999C8.32358 24.588 8.48549 24.7332 8.67835 24.7332H23.3236C23.5141 24.7332 23.6783 24.5904 23.7022 24.3999L25.5212 10.5761C25.5403 10.4165 25.3664 10.3046 25.2283 10.388ZM22.2283 23.1046H9.76882L8.48787 13.357L11.8164 15.407L15.9998 9.82607L20.1831 15.407L23.5117 13.357L22.2283 23.1046ZM15.9998 15.9237C14.5212 15.9237 13.3188 17.1261 13.3188 18.6046C13.3188 20.0832 14.5212 21.2856 15.9998 21.2856C17.4783 21.2856 18.6807 20.0832 18.6807 18.6046C18.6807 17.1261 17.4783 15.9237 15.9998 15.9237ZM15.9998 19.7546C15.3664 19.7546 14.8522 19.2404 14.8522 18.6046C14.8522 17.9713 15.3664 17.4546 15.9998 17.4546C16.6331 17.4546 17.1474 17.9689 17.1474 18.6046C17.1474 19.238 16.6331 19.7546 15.9998 19.7546Z",
    fill: "#854ECA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsNew);
export default __webpack_public_path__ + "static/media/is_new.5e5c91b159aeebb11354c955f88609f0.svg";
export { ForwardRef as ReactComponent };